import React, { useRef, useState, useEffect } from "react";
import { sponsorRegistration } from "../../../../../core/data/json/contractFarming";
import ConditionsTable from "./Conditions";
import { useSelector } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
// import CommonTextEditor from "../../../core/common/textEditor";
import { newAggrement } from "../../../../auth/services/apiCalling";
import { approve_reject } from "../../../../auth/services/apiCalling";
import { getAggreementFormReview } from "../../../../auth/services/apiCalling";
import { all_routes } from "../../../../router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from 'yup';
// import { Modal } from "bootstrap";
import { submitContractFarmingFilesAgreement } from "../../../../auth/services/privateapicalling";
import { getAllAPMC } from "../../../../auth/services/apiCalling";
import { getCFStampDOC } from '../../../../auth/services/privateapicalling';

// CSS for reduced placeholder opacity and validation styling
const placeholderStyles = `
  .low-opacity-placeholder::placeholder {
    opacity: 0.5 !important;
    color: #6c757d !important;
  }
  .low-opacity-placeholder::-webkit-input-placeholder {
    opacity: 0.5 !important;
    color: #6c757d !important;
  }
  .low-opacity-placeholder::-moz-placeholder {
    opacity: 0.5 !important;
    color: #6c757d !important;
  }
  .low-opacity-placeholder:-ms-input-placeholder {
    opacity: 0.5 !important;
    color: #6c757d !important;
  }
  
  /* Validation error styling */
  .validation-error {
    border-bottom: 2px solid #dc3545 !important;
    background-color: #fff5f5 !important;
  }
  .validation-error:focus {
    border-bottom: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
  }
`;

interface SponsorReg {
  onNext: () => void;
  applicationIdData?: any;
  reviewedData1?: any
  isEnable1?: any;
  appdata1?: any;
  licenseProof1?: any;
  setProductDetails?: any;
  conditionsData: any;
  setConditionsData?: any;
}
const validationSchema = Yup.object().shape({
  at: Yup.string().required("Input Required"),
  on_the: Yup.string().required("Input Required"),
  day_of: Yup.string().required("Input Required"),
  two_Hundr: Yup.string().required("Input Required"),
  farmarName: Yup.string().required("Input Required"),
  companyName: Yup.string().required("Input Required"),
  aggrement_age: Yup.number().typeError("age must be a number.").required("age is required.")
    .min(5, "Age must be at least 5.")
    .max(100, "Age must be at most 100."),
  residing_at: Yup.string().required("Input Required"),
  Shri_M_s: Yup.string().required("Input Required"),
  registered_office_at: Yup.string().required("Input Required"),
  first_party: Yup.string().required("Input Required"),
  second_party: Yup.string().required("Input Required"),

  periodOfMonths: Yup.number().required("Input Required"),
  // periodOfMonths2: Yup.number().required("Input Required"),
  contractedProduce: Yup.string().required("Input Required"),
  registrationAuthority: Yup.string().required("Input Required"),
  registrationDate: Yup.string().required("Input Required"),
  regardingAuthority: Yup.string().required("Input Required"),
  landDescriptionReference: Yup.string().required("Input Required"),
  singlePointRegistrationDate: Yup.string().required("Input Required"),
  singlePointAuthorityName: Yup.string().required("Input Required"),
  feeAuthority: Yup.string().required("Input Required"),
  registeringAuthorityName: Yup.string().required("Input Required"),
  addressChangeAuthority: Yup.string().required("Input Required"),

  dateOFAgreement: Yup.string().required("Input Required"),
  deliveryPoint: Yup.string().required("Input Required"),
  costOFDelivery: Yup.string().required("Input Required"),
  periodOfDelivery: Yup.string().required("Input Required"),
  dateOfScheduled: Yup.string().required("Input Required"),
  modeOfPayment: Yup.string().required("Input Required"),
  placeOfPayment: Yup.string().required("Input Required"),
  grade: Yup.string().required("Input Required"),
  specifications: Yup.string().required("Input Required"),
  quantity: Yup.string().required("Input Required"),
  price: Yup.string().required("Input Required"),

  o_field1: Yup.string().required("Input is required"),
  o_field2: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  o_field3: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  o_field4: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  o_field5: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  o_field6: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  o_field7: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  o_field8: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  o_field9: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  return_for_period: Yup.string().required("Input Required"),
  provisions_of: Yup.string().required("Input Required"),
  sign_CF_sponsor: Yup.string().required("Input Required"),

  p_field1: Yup.string().required("Input required"),
  p_field2: Yup.string().required("Input required"),
  p_field3: Yup.string().required("Input required"),
  p_field4: Yup.string().required("Input required"),
  p_field5: Yup.string().required("Input required"),
  p_field6: Yup.string().required("Input required"),
  p_field7: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
  p_field8: Yup.number().typeError("Input must be a number").positive("Input must be greater than zero").required("Input required"),
})


const validationSchema2 = Yup.array().of(
  Yup.object().shape({
    Village_Name: Yup.string().required("Village Required"),
    Farmer_Name: Yup.string().required("Farmer Name Required"),
    Survey_No: Yup.string().required("Survey No Required"),
    Area_Hectar: Yup.string().required("Area Required"),
    Tehsil: Yup.string().required("Tehsil Required"),
    District_Name: Yup.string().required("District Required"),
    // State: Yup.string().required("State Required"),
  })
);

const SponsorAgreementP1 = ({ onNext, applicationIdData, reviewedData1, isEnable1, appdata1, licenseProof1, setProductDetails, conditionsData, setConditionsData }: SponsorReg) => {

  const token = useSelector((state: any) => state.auth.token);
  const [isModalClose, setIsModalClose] = useState(true)
  const navigate = useNavigate();
  const routes = all_routes;
  const [uploadLoading, setUploadLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  // Conditions table states
  // const [conditionsData, setConditionsData] = useState<ConditionItem[]>(sponsorRegistration);
  const [comment, setComment] = useState<string>("")
  const [formErrors, setFormErrors] = useState<any>({});
  const [tableErrors, setTableErrors] = useState<any>({});
  const [appstatus, setAppstatus] = useState<any>({})
  const [tableConditionData, setTableConditionData] = useState<any>();
  const [checked1, setChecked1] = useState<any>(false);
  const [role, setRole] = useState("self"); // it is either sponsor is filling or company is filling the form
  const [behalfFile, setBehalfFile] = useState<any>(null)
  const [openModel, setOpenModel] = useState<any>(false);
  const [distrincData, setDistrincData] = useState<any>([])
  const [isload, setIsLoad] = useState<any>(false);
  const [file, setFile] = useState<any>({});
  const [rejectFile, setRejectFile] = useState<any>({});
  const [behalfLoading, setBehalfLoading] = useState<any>(false);
  const [reuploadDocId, setReuploadDocId] = useState();
  const mainLoader = useSelector((state: any) => state.auth.mainLoader);


  const [condFields, setCondFields] = useState({ ///yash's code
    periodOfMonths: '',
    periodOfMonths2: '',
    contractedProduce: '',
    registrationAuthority: '',
    registrationDate: '',
    regardingAuthority: '',
    landDescriptionReference: '',
    singlePointRegistrationDate: '',
    singlePointAuthorityName: '',
    feeAuthority: '',
    registeringAuthorityName: '',
    addressChangeAuthority: '',
    ///Tables's Fields
    dateOFAgreement: '',
    deliveryPoint: '',
    costOFDelivery: '',
    periodOfDelivery: '',
    dateOfScheduled: '',
    modeOfPayment: '',
    placeOfPayment: '',
    grade: '',
    specifications: '',
    quantity: '',
    price: ''
  })

  const getCondTableData = (values: any) => {
    setCondFields(prev => ({
      ...prev,
      ...values
    }));
  }
 
  //helper func for farmarTable's column to show error 
  const hasColumnError = (errors: any, fieldName: any) => {
    if (!errors) return false;

    return Object.values(errors).some(rowErrors => rowErrors[fieldName]);
  };

  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const currentDay = dayNames[new Date().getDay()];

  const presentDate = (() => {
    const d = new Date();
    return String(d.getDate()).padStart(2, '0');
  })();

  const presentMonth = (() => {
    const d = new Date();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthNames[d.getMonth()];
  })();

  const presentYear = (() => {
    const d = new Date();
    return String(d.getFullYear());
  })();

  const [buttonValue, setButtonValue] = useState(null);

  const [formData, setFormData] = useState({
    at: "",
    //checkout line 352 as well for changes in on day date year as API is calling as well at the same time
    on_the: currentDay,
    day_of: presentDate + " - " + presentMonth,
    two_Hundr: presentYear.slice(-2),
    farmarName: "",
    companyName: "",
    aggrement_age: "",
    residing_at: "",
    Shri_M_s: "",
    registered_office_at: "",

    first_party: "",
    second_party: "",

    o_field1: '',
    o_field2: '',
    o_field3: '',
    o_field4: '',
    o_field5: '',
    o_field6: '',
    o_field7: '',
    o_field8: '',
    o_field9: '',
    return_for_period: '',
    provisions_of: '',
    sign_CF_sponsor: '',

    p_field1: '',
    p_field2: '',
    p_field3: '',
    p_field4: '',
    p_field5: '',
    p_field6: '',
    p_field7: '',
    p_field8: ''
  });

  // Farmers table states
  const [rows, setRows] = useState([{
    Village_Name: "",
    Farmer_Name: "",
    Survey_No: "",
    Area_Hectar: "",
    Tehsil: "",
    TehsilOptions: [],   // <-- added for independent tehsil list
    District_Name: "",
    State: "Gujarat",
  }]);

  

  const validateForm = async (formData: any, condFields: any) => {
    try {
      const mergedData = { ...formData, ...condFields };
      await validationSchema.validate(mergedData, { abortEarly: false });
      return {}; // No errors
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errorMap = {};
        error.inner.forEach(err => {
          // Only keep the first error per field
          if (!errorMap[err.path]) {
            errorMap[err.path] = err.message;
          }
        });
        return errorMap;
      } else {
       
        return { general: "Unexpected error" };
      }
    }
  };

  const validateFarmarTable = async (rows: any) => {
    try {
      await validationSchema2.validate(rows, { abortEarly: false });
      return {}; // No errors
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errorMap = {};

        error.inner.forEach(err => {
          const [index, field] = err.path.replace("[", "").replace("]", "").split(".");

          if (!errorMap[index]) {
            errorMap[index] = {};
          }

          if (!errorMap[index][field]) {
            errorMap[index][field] = err.message;
          }
        });

        return errorMap;
      } else {
        
        return { general: "Unexpected error" };
      }
    }
  };

  const getProductDetails = () => {
    const filteredItems = reviewedData1?.uploadedText?.Cultivation?.filter((item: any) =>
      ["6", "7", "19"].includes(item?.itemNo)
    );
    const result = {
      dateOFAgreement: '',
      deliveryPoint: '',
      costOFDelivery: '',
      dateOfScheduled: '',
      modeOfPayment: '',
      placeOfPayment: '',
      grade: '',
      specifications: '',
      quantity: '',
      price: '',
      periodOfDelivery: ''
    };
    filteredItems?.forEach((item: any) => {
      if (item?.itemNo === "6") {
        result.dateOFAgreement = item?.dateOFAgreement;
        result.deliveryPoint = item?.deliveryPoint;
        result.costOFDelivery = item?.costOFDelivery;
        result.periodOfDelivery = item?.periodOfDelivery;
      }
      if (item?.itemNo === "7") {
        result.dateOfScheduled = item?.dateOfScheduled;
        result.modeOfPayment = item?.modeOfPayment;
        result.placeOfPayment = item?.placeOfPayment;
      }
      if (item?.itemNo === "19") {
        result.grade = item?.grade;
        result.specifications = item?.specifications;
        result.quantity = item?.quantity;
        result.price = item?.price;
      }
    });

    setProductDetails(result);
  }

  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;

  const aggrementReviewData = async () => {
    const resp = await getAggreementFormReview(token, appdata1?.Sponsor_Id);

    if (resp?.success == true) {
      if (resp?.data?.buttonName && resp?.data?.buttonName.length > 0) setButtonValue(resp?.data?.buttonName[0] || "");
    } else {
      toast.error(resp?.message, { position: "top-right" });
    }
  }

  useEffect(() => {
    if (appdata1?.Sponsor_Id) {
      aggrementReviewData()
    }

  }, [appdata1?.Sponsor_Id])

  useEffect(() => {
    if (roleIdentifier !== "SPO") {
      getProductDetails();

      if (reviewedData1?.uploadedText?.Cultivation) {
        const uploadedCultivation = reviewedData1.uploadedText.Cultivation;
        const deletedItemNos = reviewedData1.deletedItemNos || [];

        const updatedConditions = sponsorRegistration.map(templateCondition => {
          const uploadedCondition = uploadedCultivation.find((item: any) => item.itemNo === templateCondition.itemNo);
          const isDeleted = deletedItemNos.includes(templateCondition.itemNo);

          if (isDeleted) {
            return { ...templateCondition, status: 'deleted' as const };
          }

          if (uploadedCondition) {
            const merged = {
              ...templateCondition,
              ...uploadedCondition,
              isTableExist: typeof uploadedCondition.isTableExist === 'boolean' ? uploadedCondition.isTableExist : !!templateCondition.isTableExist,
              tableItems: Array.isArray(uploadedCondition.tableItems) ? uploadedCondition.tableItems : (templateCondition.tableItems || []),
              isBlankExist: typeof uploadedCondition.isBlankExist === 'boolean' ? uploadedCondition.isBlankExist : !!templateCondition.isBlankExist,
              blank: Array.isArray(uploadedCondition.blank) ? uploadedCondition.blank : (templateCondition.blank || []),
              status: uploadedCondition.status || 'normal',
            };

            if (templateCondition.itemNo === "2") {
              if (merged.periodOfMonths && !merged.periodOfMonths2) {
                merged.periodOfMonths2 = merged.periodOfMonths;
              } else if (merged.periodOfMonths2 && !merged.periodOfMonths) {
                merged.periodOfMonths = merged.periodOfMonths2;
              }
            }

            return merged;
          }
          return templateCondition;
        });

        const newSubmittedConditions = uploadedCultivation.filter((uc: any) =>
          parseInt(uc.itemNo, 10) > 19 && !updatedConditions.some(tc => tc.itemNo === uc.itemNo)
        ).map((uc: any) => ({
          ...uc,
          status: uc.status || 'added',
        }));

        setConditionsData([...updatedConditions, ...newSubmittedConditions]);
      }
    } else if (roleIdentifier === "SPO" && isEnable1 && reviewedData1?.uploadedText?.Cultivation) {
      const uploadedCultivation = reviewedData1.uploadedText.Cultivation;
      const deletedItemNos = reviewedData1.deletedItemNos || [];

      const updatedConditions = sponsorRegistration.map(templateCondition => {
        const uploadedCondition = uploadedCultivation.find((item: any) => item.itemNo === templateCondition.itemNo);
        const isDeleted = deletedItemNos.includes(templateCondition.itemNo);

        if (isDeleted) {
          return { ...templateCondition, status: 'deleted' as const };
        }

        if (uploadedCondition) {
          const merged = {
            ...templateCondition,
            ...uploadedCondition,
            isTableExist: typeof uploadedCondition.isTableExist === 'boolean' ? uploadedCondition.isTableExist : !!templateCondition.isTableExist,
            tableItems: Array.isArray(uploadedCondition.tableItems) ? uploadedCondition.tableItems : (templateCondition.tableItems || []),
            isBlankExist: typeof uploadedCondition.isBlankExist === 'boolean' ? uploadedCondition.isBlankExist : !!templateCondition.isBlankExist,
            blank: Array.isArray(uploadedCondition.blank) ? uploadedCondition.blank : (templateCondition.blank || []),
            status: uploadedCondition.status || 'normal',
          };

          if (templateCondition.itemNo === "2") {
            if (merged.periodOfMonths && !merged.periodOfMonths2) {
              merged.periodOfMonths2 = merged.periodOfMonths;
            } else if (merged.periodOfMonths2 && !merged.periodOfMonths) {
              merged.periodOfMonths = merged.periodOfMonths2;
            }
          }

          return merged;
        }
        return templateCondition;
      });

      const newSubmittedConditions = uploadedCultivation.filter((uc: any) =>
        parseInt(uc.itemNo, 10) > 19 && !updatedConditions.some(tc => tc.itemNo === uc.itemNo)
      ).map((uc: any) => ({
        ...uc,
        status: uc.status || 'added',
      }));
      setConditionsData([...updatedConditions, ...newSubmittedConditions]);
    }

    // REMOVED formData from dependencies - this was causing the reset!
  }, [reviewedData1, roleIdentifier, isEnable1]);

  const resetFieldsInItems = (items: any) => {
    const fieldsToRemove = [
      "periodOfMonths",
      "contractedProduce",
      "registeringAuthorityName",
      "addressChangeAuthority",

      "registrationAuthority",
      "registrationDate",
      "regardingAuthority",
      "landDescriptionReference",
      "singlePointRegistrationDate",
      "singlePointAuthorityName",
      "feeAuthority"
    ];
    return items.map((item: any) => {

      // Remove the keys from the object
      fieldsToRemove.forEach(key => {
        if (key in item) {
          delete item[key];
        }
      });

  
    });
  };


 

  useEffect(() => {

    if (reviewedData1) {
      setFormData(prev => ({
        ...prev,
        at: reviewedData1?.agreement_At || "",
        on_the: reviewedData1?.agreement_on_the || currentDay,
        day_of: reviewedData1?.agreement_day_of || presentDate + " - " + presentMonth,
        two_Hundr: reviewedData1?.agreement_twozerozero || presentYear.slice(-2),
        farmarName: reviewedData1?.Farmer_Name || "",
        companyName: reviewedData1?.Company_Name || "",
        aggrement_age: reviewedData1?.agreement_age || "",
        residing_at: reviewedData1?.agreement_residingAt || "",
        Shri_M_s: reviewedData1?.AgreementFirstPartyName || "",
        // Populate registered office from any available key
        registered_office_at: reviewedData1?.AgreementFirstOfficeAt
          || reviewedData1?.AgreementFirstOfficeAt
          || reviewedData1?.registered_office_at
          || "",

        o_field1: reviewedData1?.quarterForWhichReportPertains,
        o_field2: reviewedData1?.totalQuantityPurchasedTonnes,
        o_field3: reviewedData1?.totalValuePurchased,
        o_field4: reviewedData1?.totalSupervisionChargesAssessed,
        o_field5: reviewedData1?.totalSupervisionChargesPaid,
        o_field6: reviewedData1?.totalQuantityForExportTonnes,
        o_field7: reviewedData1?.quantityForProcessingExportTonnes,
        o_field8: reviewedData1?.quantityOfAgrProExports,
        o_field9: reviewedData1?.quantityProcessedExportedTonnes,
        return_for_period: reviewedData1?.returnForPeriodOf,
        provisions_of: reviewedData1?.provisionsOf,
        sign_CF_sponsor: reviewedData1?.signOfContractFarmingSponsor,

        p_field1: reviewedData1?.nameOfCommodity,
        p_field2: reviewedData1?.nOoFfARMERContractSigned,
        p_field3: reviewedData1?.areainHa,
        p_field4: reviewedData1?.quantityInTonnes,
        p_field5: reviewedData1?.totalQuantityOfProducePurchased,
        p_field6: reviewedData1?.valPaidtoFarmers,
        p_field7: reviewedData1?.paymentOutNoFarmers,
        p_field8: reviewedData1?.paymentOutstandingAmount,


        first_party: reviewedData1?.FirstPartyPresenceName || "",
        second_party: reviewedData1?.SecondPartyPresenceName || "",
      }));

      const villages = reviewedData1?.textField?.villageData || reviewedData1?.Village_details;
      if (villages?.length) {
        setRows(
          villages.map((village: any) => {
            // Find the district object for this village
            const selectedDist = distrincData?.find(
              (item: any) => item?.District === village.District_Name
            );

            return {
              Village_Name: village.Village_Name || "",
              Farmer_Name: village.Farmer_Name || "",
              Survey_No: village.Survey_No || "",
              Area_Hectar: village.Area_Hectar || "",
              Tehsil: village.Tehsil || "",
              District_Name: village.District_Name || "",
              State: village.State || "Gujarat",
              TehsilOptions: selectedDist?.Tehsils || [], // <-- add TehsilOptions per row
            };
          })
        );
      }


    }

  }, [reviewedData1]);

  const [editingSubItem, setEditingSubItem] = useState<{
    itemNo: string;
    subIdx: number;
  } | null>(null);
  const [editingSubText, setEditingSubText] = useState("");

  // Define the type for a condition item including isUpdated
  interface ConditionItem {
    itemNo: string;
    item: string;
    isBlankExist: boolean;
    blank: any[];
    subItem: {
      subitemNo: string;
      subItemSno: string;
      subItemVal: string;
    }[];
    isTableExist: boolean;
    tableItems: any[];
    isUpdated?: boolean;
    status?: 'normal' | 'deleted' | 'updated' | 'added'; // To change conditons 
  }

  // Function to calculate text width and adjust input width
  const adjustInputWidth = (text: string, placeholder: string = "", minWidth: number = 200) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = "1.25rem Arial";
      const textWidth = context.measureText(text).width;
      const placeholderWidth = context.measureText(placeholder).width;
      // Use the larger of current text or placeholder width, with some padding
      const maxWidth = Math.max(textWidth, placeholderWidth);
      return Math.max(minWidth, maxWidth + 20);
    }
    return minWidth;
  };

  // Validation helper function for numeric fields
  const validateNumericInput = (value: string, allowDecimal: boolean = false, maxLength?: number): string => {
    // Remove any non-numeric characters (except decimal point if allowed)
    let cleaned = value;
    if (allowDecimal) {
      // Allow numbers and one decimal point
      cleaned = value.replace(/[^\d.]/g, '');
      // Ensure only one decimal point
      const parts = cleaned.split('.');
      if (parts.length > 2) {
        cleaned = parts[0] + '.' + parts.slice(1).join('');
      }
    } else {
      // Only allow digits
      cleaned = value.replace(/[^\d]/g, '');
    }
    // Apply max length if specified
    if (maxLength && cleaned.length > maxLength) {
      cleaned = cleaned.substring(0, maxLength);
    }
    return cleaned;
  };

 

  const handleInputChange = (field: string, value: any) => {
    let validatedValue = value;

    if (field === 'two_Hundr') {
      validatedValue = validateNumericInput(value, false, 2);
    }
    // else if (field === 'aggrement_age') {
    //   validatedValue = validateNumericInput(value, false);
    // }

    setFormData((prev) => ({
      ...prev,
      [field]: validatedValue,
    }));

    setFormErrors((prevErrors: any) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });

  };

  const addRow = () => {
    setRows([...rows, {
      Village_Name: "",
      Farmer_Name: "",
      Survey_No: "",
      Area_Hectar: "",
      Tehsil: "",
      TehsilOptions: [],
      District_Name: "",
      State: "Gujarat",
    }]);
  };

  const handleFarmerInputChange = (index: any, name: any, value: any) => {
    let validatedValue = value;

    if (name === 'Survey_No') {
      validatedValue = validateNumericInput(value, false);
    } else if (name === 'Area_Hectar') {
      validatedValue = validateNumericInput(value, true);
    }

    const updatedRows = [...rows];
    updatedRows[index][name] = validatedValue;

    // If District_Name changes, update TehsilOptions for this row only
    if (name === 'District_Name') {
      const selectedDist = distrincData?.find(
        (item: any) => item?.District === validatedValue
      );

      updatedRows[index].TehsilOptions = selectedDist?.Tehsils || [];
      updatedRows[index].Tehsil = ""; // reset selected tehsil
      setRows(updatedRows);  // Fetch tehsil for this row only
      if (selectedDist?.district_id) {
        getTehsil(index, selectedDist?.district_id);
      }
    }


    // // Remove error for this field if any
    setTableErrors((prevErrors: any) => {
      if (!prevErrors) return prevErrors;

      const updatedErrors = { ...prevErrors };

      // Example: remove error in a specific row + field
      if (updatedErrors[index]) {
        delete updatedErrors[index][name];

        // If row has no more errors, remove row entirely
        if (Object.keys(updatedErrors[index]).length === 0) {
          delete updatedErrors[index];
        }
      }

      return updatedErrors;
    });

  };


  const deleteRow = (indexToDelete: number) => {
    if (rows.length > 1) {
      // Keep at least one row
      setRows(rows.filter((_, index) => index !== indexToDelete));
    }
  };

  // Auto-fill function for testing
  // Function to inject values into HTML input fields
  const injectValuesIntoHTML = (html: string, condition: any) => {
    if (!condition.isBlankExist || !Array.isArray(condition.blank)) {
      return html;
    }

    let updatedHTML = html;

    condition.blank.forEach((blankItem: any) => {
      const { blankVal, blankName } = blankItem;
      const value = condition[blankVal] || "";

      // Match any <input ... name="blankVal" ...> regardless of attribute order/type; support both > and />
      const inputByNameRegex = new RegExp(
        `<input\\s+([^>]*?)name=[\"\']${blankVal}[\"\']([^>]*)>`,
        'gi'
      );

      // Replacement builder that preserves other attributes but injects value and placeholder
      const replacer = (_match: string, preAttrs: string, postAttrs: string) => {
        // Remove any existing value attribute to avoid duplicates
        const attrs = `${preAttrs} ${postAttrs}`
          .replace(/\s+value=[\"\'][^\"\']*[\"\']/gi, '')
          .trim();
        const placeholderAttr = blankName ? ` placeholder=\"Enter ${blankName}\"` : '';
        return `<input ${attrs} value=\"${value}\"${placeholderAttr}>`;
      };

      updatedHTML = updatedHTML.replace(inputByNameRegex, replacer);
    });

    return updatedHTML;
  };

  const newAggrementSubmition = async () => {

    if (!applicationIdData?.applicationId) {
      try {
        toast.error("Missing application ID. Please reload the page and try again.", {
          position: "top-right",
          toastId: 'missing-app-id',
        });
      } catch (e) {
  
      }
      return;
    }
    if (role === "behalf" && !behalfFile && !(behalfFile?.length > 0)) {
      toast.error("Please Upload Document First !", {
        position: "top-right",
        toastId: 'missing-app-id',
      });
      return;
    }

    const cleanCultivation = conditionsData.map((cond: any) => ({
      ...cond,
      itemNo: String(cond.itemNo),      // normalize to string
      isBlankExist: !!cond.isBlankExist,
      isTableExist: !!cond.isTableExist,
      blank: Array.isArray(cond.blank) ? cond.blank : [],
      subItem: Array.isArray(cond.subItem) ? cond.subItem : [],
      tableItems: Array.isArray(cond.tableItems) ? cond.tableItems : [],
    }));

    const deletedItemNos = conditionsData
      .filter((c: any) => c?.status === 'deleted')
      .map((c: any) => String(c.itemNo));

    const objbody = {
      couchId: applicationIdData?.applicationDataId,
      formData: formData,
      tablerows: rows,
      conditionsData: conditionsData, // Keep existing for backward compatibility
      aggrement: { Cultivation: cleanCultivation }, // Add cleaned conditions to aggrement.Cultivation
      deletedItemNos, // Explicit list for downstream consumers
    }

    try {
      setSubmitLoading(true)
      const res = await newAggrement(token, objbody, applicationIdData);
      if (res?.success == true) {
        setOpenModel(true)

        toast.success(res?.message || "Agreement submitted successfully!", {
          position: "top-right",
          toastId: 'agreement-success'
        });
        const dd = resetFieldsInItems(conditionsData)
       
        // setConditionsData((prev: any) => resetFieldsInItems(structuredClone(prev)));

      } else {
        toast.error(res?.message || "Failed to submit agreement", {
          position: "top-right",
          toastId: 'agreement-error'
        });
      }
    } catch (toastError) {
     

    } finally {
      setSubmitLoading(false);
      // setOpenModel(false)
    }
  }



  const [isSubmitting, setIsSubmitting] = useState(false);

  const approveReject = async (st: any, comment: any) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const licenseProof = {
        licenseProof1
      }
      setSubmitLoading(true);
      const cleanCultivation = conditionsData.map((cond: any) => ({
        ...cond,
        itemNo: String(cond.itemNo),
        isBlankExist: !!cond.isBlankExist,
        isTableExist: !!cond.isTableExist,
        blank: Array.isArray(cond.blank) ? cond.blank : [],
        subItem: Array.isArray(cond.subItem) ? cond.subItem : [],
        tableItems: Array.isArray(cond.tableItems) ? cond.tableItems : [],
      }));

      const itemsArray = cleanCultivation.map((item: any) => ({
        ...item,
        isDeleted: item?.status === 'deleted'
      }));

      // Full textField including villageData
      const fullTextField = {
        agreement_At: formData?.at,
        agreement_on_the: formData?.on_the,
        agreement_day_of: formData?.day_of,
        agreement_twozerozero: formData?.two_Hundr,
        Farmer_Name: formData?.farmarName,
        Company_Name: formData?.companyName,
        agreement_age: formData?.aggrement_age,
        agreement_residingAt: formData?.residing_at,
        AgreementFirstPartyName: formData?.Shri_M_s,
        AgreementFirstOfficeAt: formData?.registered_office_at,
        FirstPartyPresenceName: formData?.first_party,
        SecondPartyPresenceName: formData?.second_party,

        returnForPeriodOf: formData?.return_for_period,
        provisionsOf: formData?.provisions_of,
        signOfContractFarmingSponsor: formData?.sign_CF_sponsor,

        quarterForWhichReportPertains: formData?.o_field1,
        totalQuantityPurchasedTonnes: formData?.o_field2,
        totalValuePurchased: formData?.o_field3,
        totalSupervisionChargesAssessed: formData?.o_field4,
        totalSupervisionChargesPaid: formData?.o_field5,
        totalQuantityForExportTonnes: formData?.o_field6,
        quantityForProcessingExportTonnes: formData?.o_field7,
        quantityOfAgrProExports: formData?.o_field8,
        quantityProcessedExportedTonnes: formData?.o_field9,

        nameOfCommodity: formData?.p_field1,
        nOoFfARMERContractSigned: formData?.p_field2,
        areainHa: formData?.p_field3,
        quantityInTonnes: formData?.p_field4,
        totalQuantityOfProducePurchased: formData?.p_field5,
        valPaidtoFarmers: formData?.p_field6,
        paymentOutNoFarmers: formData?.p_field7,
        paymentOutstandingAmount: formData?.p_field8
        // villageData: rows,
      };
      const submittedFields: any = {
        ...fullTextField,
        Cultivation: conditionsData,
        doc_id: reuploadDocId
      };

      if (newlyUploaded?.rejectionFile?.docId) {
        submittedFields.rejectionFile = {
          data: {
            docId: newlyUploaded?.rejectionFile?.docId,
            documentName: newlyUploaded?.rejectionFile?.documentName,
            fileName: newlyUploaded?.rejectionFile?.fileName,
          }
        };
      }

      const objbody: any = {
        applicationId: appdata1?.Sponsor_Id,
        status: st?.status,
        appStatusLevel: st?.appStatusLevel,
        comment: comment || "",
        submittedFields,
        couchId: reviewedData1?.applicationDataId,
      }

      const res = await approve_reject(token, objbody);
      if (res?.success == true) {
        if (roleIdentifier === "MBA") {
          toast.success(" Your agreement form has been successfully submitted to the Marketing Board Administrator for review.", {
            position: "top-right",

          });
        }
        if (roleIdentifier === "MBMD") {
          if (st?.appStatusLevel === "forwardToSponsorAterApproval" || st?.appStatusLevel === "forwardToSponsorAterApproval") {
            toast.success(" Your agreement form has been forwarded to the Sponsor.", {
              position: "top-right",
            });
          } else if (st?.appStatusLevel === "fillFormJResubmission" || st?.appStatusLevel === "forwardToSpoAfterApprovalResubmissionn") {
            toast.success(" Your agreement form has been sent back to the Sponsor for resubmission.", {
              position: "top-right",
            });
          } else if (st?.appStatusLevel === "applicationRejected") {
            toast.success(" The agreement form has been rejected successfully.", {
              position: "top-right",
            });
          }
        } else if (roleIdentifier === "SPO") {
          if (st?.appStatusLevel === "pendingAtMBAResubmission" || st?.appStatusLevel === "forwardToSponsorAterApproval") {
            toast.success(" Your agreement resubmission form has been successfully forwarded to the Marketing Board Administrator.", {
              position: "top-right",
            });
          }
        }

        setTimeout(() => {
          // navigate(routes.menuMarketingBoardAgreement, { state: { filter: st } });
          navigate(routes.sponsorAgreementPending, { state: { filter: st } });
        }, 2000);
        setIsModalClose(true);

      } else {
        try {
          toast.error(res?.message || "Failed to process request", {
            position: "top-right",
            toastId: 'approve-error'
          });
        } catch (toastError) {
         
        }
      }
    } catch (error) {
     
    } finally {
      setIsSubmitting(false); // Only allow future submissions if needed
      setSubmitLoading(false);
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



  const handleApproved = async () => {
    if (!comment || comment.trim() === "") {
      toast.error("Please enter remarks before approving", { position: "top-right" });
      return;
    }

    const errors = await validateForm(formData, condFields);
    const errors2 = await validateFarmarTable(rows);
    if (Object.keys(errors).length === 0 && Object.keys(errors2).length === 0) {

      approveReject(appstatus, comment);

    } else {
      setFormErrors(errors);
      setTableErrors(errors2);

      setOpenModel(true)
    }
  }
  /////////////////////////////////////////////88888888888888888888888888888888888888888888888888888888888888888888888888888888888888888
  const handleForwardToMD = async () => {
    if (!comment || comment.trim() === "") {
      toast.error("Please enter remarks first", { position: "top-right" });
      return;
    }
    const errors = await validateForm(formData, condFields);
    const errors2 = await validateFarmarTable(rows);
    if (Object.keys(errors).length === 0 && Object.keys(errors2).length === 0) {

      approveReject(appstatus, comment);

    } else {
      setFormErrors(errors);
      setTableErrors(errors2);

      setOpenModel(true)
    }
  }
  // State to track newly uploaded files
  const [newlyUploaded, setNewlyUploaded] = useState<any>({});

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string
  ) => {
    const { files } = e.target;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
    const minSize = 40 * 1024;

    if (!allowedTypes.includes(files[0]?.type)) {
      toast.info("Only PDF, JPG, JPEG and PNG files are allowed.", { position: "top-right" });
      e.target.value = ""; // reset the input
      return;
    }
    if (files[0]?.size < minSize) {
      toast.info("File size must be at least 40 KB.", { position: "top-right" });
      e.target.value = ""; // reset the input
      return;
    }

    setBehalfFile(files); ///state for validation of onSubmit the
  
    if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      handleUpload(fileName, file, fieldName, formData[fieldName]?.docId);
    }
  };

  const handleUpload = async (
    documentName: string,
    file: any,
    fieldName: string,
    docId?: string | null
  ) => {
    // Validate applicationId exists
    if (appdata1?.Sponsor_Id || applicationIdData?.applicationId) {
      // Use same variable name as working file
      const formData2 = new FormData();
      formData2.append("file", file);
      formData2.append("documentName", documentName);
      formData2.append("fieldName", fieldName);
      if (appdata1?.Sponsor_Id) formData2.append("applicationId", String(appdata1?.Sponsor_Id));
      if (applicationIdData?.applicationId) formData2.append("applicationId", String(applicationIdData?.applicationId));
      try {
        setUploadLoading(true);
        const res = await submitContractFarmingFilesAgreement(formData2, token, docId);
        setReuploadDocId(res?.docId);
        
        if (res.success == false) {
          toast.error(res?.message, { position: "top-right" });
        } else if (res?.success && res?.docId) {
          setFormData((prev) => ({
            ...prev,
            [fieldName]: {
              docId: res.docId,
              documentName: fieldName,
              fileName: documentName,
            },
          }));
          setNewlyUploaded((prev: any) => ({
            ...prev,
            [fieldName]: {
              docId: res.docId,
              documentName: fieldName,
              fileName: documentName,
            }
          }));
          toast.success(res?.message || "File uploaded successfully", {
            position: "top-right"
          });
        }
      } catch (error) {
     
        toast.error("File upload failed", { position: "top-right" });
      } finally {
        setUploadLoading(false);
      }

    } else {
      toast.error("Application ID is missing. Please reload the page.", {
        position: "top-right"
      });
    
      return;
    }
  };

  //apply validation...
  const handleAgreementSubmit = async () => {

    // isResetVal(!resetVal)
    const errors = await validateForm(formData, condFields);
    const errors2 = await validateFarmarTable(rows);
    if (Object.keys(errors).length === 0 && Object.keys(errors2).length === 0) {

      if (appdata1?.appStatusLevel == "forwardToSponsorAterApproval") {
        if (licenseProof1?.data?.docId && licenseProof1?.data?.documentName) {
          approveReject("forwardToMBAAterApproval", '');
        } else {
          try {
            toast.error("Upload Document first !", {
              position: "top-right",
              toastId: 'upload-error'
            });
          } catch (toastError) {
            
          }
        }
      } else if (appdata1?.appStatusLevel == "fillFormJResubmission") {
        await approveReject(buttonValue, '');
      } else {
        await newAggrementSubmition();
      }

    } else {
      setFormErrors(errors);
      setTableErrors(errors2);

      setOpenModel(true)
    }
  }

  const isDisableAggreementRole = (() => {
    const status = appdata1?.appStatusLevel;

    if (roleIdentifier === "SPO") {
      if (!status) return false; // undefined → enable button
      if (["pendingAtMBA", "pendingAtMB", "forwardToSponsorAterApproval", "forwardToMBAAterApproval", "fillFormJResubmission", "applicationRejected"].includes(status)) {
        return true;
      }
      return false;
    }
    // For other roles
    return status === "forwardToSponsorAterApproval" ? true : true;
  })();

  const isDisableFarmarTable = (() => {

    if (Object.keys(appdata1 || {}).length > 0) return true;

  })();

  /// To Get the District Api....
  const getTDistrict = async () => {
    setIsLoad(true);
    try {
      const res = await getAllAPMC(token, '', '');
      if (res?.success == true) {
      
        setDistrincData(res?.data);
      } else {
        toast.error(res?.message, { position: "top-right" });
      }
    } catch (error) {
   
      toast.error("Something went wrong while fetching District/Tehsil.", {
        position: "top-right",
      });
    } finally {
      setIsLoad(false); // 🔹 Stop loading
    }
  }

  useEffect(() => {
    getTDistrict();
  }, [])

  /// To Get the Tehsil Api....
  const getTehsil = async (index: number, districtId: string) => {
    if (!districtId) return;

    const updatedRows = [...rows];
    setRows(updatedRows);

    try {
      const res = await getAllAPMC(token, districtId, '');
      if (res?.success) {
        updatedRows[index].TehsilOptions = res.data || [];
      } else {
        toast.error(res?.message, { position: "top-right" });
      }
    } catch (error) {
     
      toast.error("Something went wrong while fetching Tehsil data.", { position: "top-right" });
    } finally {
      setRows([...updatedRows]);
    }
  };

  const districtOptions = distrincData?.map((item: any) => item.District);


  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Rejection Attachement...
  const getRejetionAttachementFile = async () => {
    const docIdd =
      reviewedData1?.pendingAtMBMD?.reSubmittedFields?.rejectionFile?.data?.docId ||
      reviewedData1?.pendingAtMBMDResubmission?.reSubmittedFields?.rejectionFile?.data?.docId ||
      reviewedData1?.forwardToMBMDAfterApprovalResubmissionn?.reSubmittedFields?.reg?.rejectionFile?.data?.docId;

    if (!docIdd) return;

    setRejectFile(null);
    setBehalfLoading(true);

    try {
      const response = await getCFStampDOC(docIdd, token);
  

      if (response.success && response.attachments) {
        const [key] = Object.keys(response.attachments);
        const attachment = response.attachments[key];

        setRejectFile({
          fileData: attachment.base64,
          mimeType: attachment.contentType,
          fileName: key,
        });
      } else {
        setRejectFile(null);
      }
    } catch (error) {
    
      setRejectFile(null);
    }
    setBehalfLoading(false);
  };

  const docIdd =
    reviewedData1?.pendingAtMBMD?.reSubmittedFields?.rejectionFile?.data?.docId ||
    reviewedData1?.pendingAtMBMDResubmission?.reSubmittedFields?.rejectionFile?.data?.docId ||
    reviewedData1?.forwardToMBMDAfterApprovalResubmissionn?.reSubmittedFields?.reg?.rejectionFile?.data?.docId;

  useEffect(() => {
    if (docIdd) getRejetionAttachementFile();
  }, [docIdd])

  const pdfUrl_RejectFile = React.useMemo(() => {
    if (!rejectFile || rejectFile.mimeType !== "application/pdf") return null;
    try {
      const base64Data = rejectFile?.fileData.split(',')[1] || rejectFile?.fileData;
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      return URL.createObjectURL(blob);
    } catch (error) {
     
      return null;
    }
  }, [rejectFile])

  useEffect(() => {
    return () => {
      if (pdfUrl_RejectFile) URL.revokeObjectURL(pdfUrl_RejectFile);
    };
  }, [pdfUrl_RejectFile]);
  ////////////////////////////////////////////////////////////////////////////////////////

  const getUploadedFile = async () => {
    if (!reviewedData1?.doc_id) return;

    setFile(null);
    setBehalfLoading(true);
  
    try {
      const response = await getCFStampDOC(reviewedData1?.doc_id, token);
    

      if (response.success && response.attachments) {
        const [key] = Object.keys(response.attachments);
        const attachment = response.attachments[key];

        setFile({
          fileData: attachment.base64,
          mimeType: attachment.contentType,
          fileName: key,
        });
      } else {
        setFile(null);
      }
    } catch (error) {
   
      setFile(null);
    }
    setBehalfLoading(false);
  };

  useEffect(() => {
    if (!reviewedData1?.doc_id) return;
    getUploadedFile()
  }, [reviewedData1?.doc_id])

  const pdfUrl = React.useMemo(() => {
    if (!file || file.mimeType !== "application/pdf") return null;
    try {
      const base64Data = file?.fileData.split(',')[1] || file?.fileData;
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      return URL.createObjectURL(blob);
    } catch (error) {
     
      return null;
    }
  }, [file])

  useEffect(() => {
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfUrl]);
  //////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className="">
      <style>{placeholderStyles}</style>
      <div className="d-flex bg-white p-5 rounded flex-column m-5 text-nightblue justify-content-center">

        
        {mainLoader && (
          <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.3)", zIndex: 1050 }}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-grow text-primary mb-3" role="status">
                <span className="visually-hidden">Data Fetching...</span>
              </div>
              <div className="fw-bold">Data Fetching, please wait...</div>
            </div>
          </div>
        )}

        {/* Show View Certificate button only for approved status */}
        {appdata1?.Status === "permanentReject" && (
          <div className="d-flex justify-content-end">
            <button
              className="btn w-25"
              style={{ backgroundColor: '#f0cecc', color: '#8c4d4f' }}
              data-bs-target="#rejection_attachement"
              data-bs-toggle="modal"
            >
              <i className="bi bi-file-earmark-check me-1"></i>
              View Rejection Attachment
            </button>
          </div>
        )}

        {roleIdentifier === "MBMD" && (
          <div className="mx-5 mb-4">
            <h4>Comment from</h4>
            <p className="fw-bold text-black" style={{ fontSize: "1.4rem" }}>
              Marketing Board Administrator:
              <span className="fw-normal bg-white p-2 rounded border border-secondary d-block mt-2 text-break" style={{ fontSize: "1.2rem" }}>
                {reviewedData1?.pendingAtMBAResubmission?.comment ? reviewedData1?.pendingAtMBAResubmission?.comment : reviewedData1?.pendingAtMBA?.comment}
              </span>
            </p>
          </div>
        )}


        {roleIdentifier === "SPO" && (appdata1?.Status === "approved" || appdata1?.Status === "reject" || appdata1?.Status === "permanentReject") && (
          <div className="mx-5 mt-4">
            <h4>Comment from</h4>
            <p className="fw-bold text-black" style={{ fontSize: "1.4rem" }}>
              Marketing Board Managing Director:
              <span className="fw-normal bg-white p-2 rounded border border-secondary d-block mt-2 text-break" style={{ fontSize: "1.2rem" }}>
                {
                  reviewedData1?.forwardToMBMDAfterApprovalResubmissionn?.comment ||
                  reviewedData1?.pendingAtMBMDResubmission?.comment ||
                  reviewedData1?.pendingAtMBMD?.comment ||
                  ""
                }
              </span>
            </p>
          </div>
        )}

        <div className="text-center mb-4">
          <h2>FORM - M</h2>
          <h2>[SEE RULE 119(3)]</h2>
          <h2>AGREEMENT OF CONTRACT FARMING</h2>

          {/* Auto-fill button for testing */}
          {/* Removed test auto-fill UI */}
        </div>

        <div className="border mb-4 text-black p-3 rounded-3">
          <div>
            <div className="mb-3">
              <h3>Agreement Role</h3>
              <p style={{ fontSize: "1.1rem" }}>
                Please specify your role in this agreement application
              </p>
            </div>

            <div className="d-flex flex-column gap-2 mb-3" style={{ fontSize: "1.1rem" }}>
              <div className="d-flex gap-2 align-items-center">
                <input
                  type="radio"
                  name="agreementRole"
                  id="self"
                  value="self"
                  defaultChecked
                  checked={reviewedData1?.agreement_behalf == null ? role === "self" : false}
                  onChange={(e) => setRole(e.target.value)}
                  disabled={isDisableAggreementRole}
                />
                <label htmlFor="self">I am making this agreement as the Sponsor (Self)</label>
              </div>

              <div className="d-flex gap-2 align-items-center">
                <input
                  type="radio"
                  name="agreementRole"
                  id="behalf"
                  value="behalf"
                  checked={reviewedData1?.agreement_behalf == null ? role === "behalf" : true}
                  onChange={(e) => setRole(e.target.value)}
                  disabled={isDisableAggreementRole}
                />
                <label htmlFor="behalf">
                  I am making this agreement on behalf of a Sponsor (Company/Representative)
                </label>
              </div>
            </div>
          </div>

          {/* Only show when second radio is selected */}
          {(reviewedData1?.agreement_behalf == null ? role === "behalf" : true) && (
            <div className="bg-gray rounded-3 border border-dark-subtle p-3">
              <div className="mb-3">
                <h3>Supporting Document Required</h3>

              </div>
              {(role === "behalf" && reviewedData1?.agreement_behalf == null || (roleIdentifier === "SPO" && !isEnable1)) ?
                <>
                  <p style={{ fontSize: "1.1rem" }}>
                    Please upload a document signed by the sponsor authorizing you to act on their behalf.
                  </p>
                  <input
                    type="file"
                    accept="image/*, application/pdf"
                    className="form-control w-100"
                    disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true : (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                    onChange={(e) => handleFileChange(e, "behalf_of_Sponsor_signed_doc")}

                  />
                </>
                :
                <>
                  <p style={{ fontSize: "1.1rem" }}>
                    Review uploaded a document signed by the sponsor authorizing you to act on their behalf.
                  </p>
                  <span className="d-flex col"> <button className="btn btn-info m-0 "
                    data-bs-target="#befalf_doc_review"
                    data-bs-toggle="modal"
                  >
                    Review
                  </button>
                  </span>
                </>
              }
            </div>
          )}
        </div>

        <div className="mb-4 text-black" style={{ fontSize: "1.25rem" }}>
          <p style={{ fontSize: "1.25rem" }} className="text-black">
            This Agreement is made and entered into at
            {formErrors?.at && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.at + `)`}</span>}
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.at ? 'text-danger border-danger' : ''}`}
              style={{
                width: `${adjustInputWidth(formData.at, formErrors?.at || "location")}px`,
                minWidth: "200px",
                // backgroundColor: agre_at?.prevValue !== '' && agre_at?.prevValue !== agre_at?.currValue ? "yellow" : ""
              }}
              placeholder={formErrors?.at || "location"}
              onChange={(e) =>
                handleInputChange("at", e.target.value)
              }
              value={formData?.at}
              disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                roleIdentifier === "SPO" ? isEnable1 === true : isEnable1}
            />
            on the
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.on_the ? 'validation-error' : ''}`}
              style={{
                // width: `${adjustInputWidth(formData?.on_the, formErrors?.on_the || "Enter Day (e.g., Monday)")}px`,
                // minWidth: "100px",
                width: "120px",
              }}
              placeholder={formErrors?.on_the || "Enter Day"}
              onChange={(e) =>
                handleInputChange("on_the", e.target.value)
              }
              value={formData?.on_the}
              disabled={true || appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            day of
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.day_of ? 'validation-error' : ''}`}
              style={{
                // width: `${adjustInputWidth(formData.day_of, formErrors?.day_of || "Enter Date (e.g., 17-oct)")}px`,
                // minWidth: "70px",
                width: "100px",
              }}
              placeholder={formErrors?.day_of || "Enter Date "}
              onChange={(e) =>
                handleInputChange("day_of", e.target.value)
              }
              value={formData?.day_of}
              disabled={true || appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            20
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.two_Hundr ? 'validation-error' : ''}`}
              style={{
                // width: `${adjustInputWidth(formData.two_Hundr, formErrors?.two_Hundr || "Enter year (e.g., 24)")}px`,
                // minWidth: "50px",
                width: "50px",
              }}
              placeholder={formErrors?.two_Hundr || "Enter year last 2 digits"}
              onChange={(e) =>
                handleInputChange("two_Hundr", e.target.value)
              }
              value={formData?.two_Hundr}
              disabled={true || appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            between
            {formErrors?.farmarName && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.farmarName + `)`}</span>}
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.farmarName ? 'text-danger border-danger' : ''}`}
              style={{
                width: `${adjustInputWidth(formData.farmarName, formErrors?.farmarName || "Enter parties (e.g., Farmer and Company)")}px`,
                minWidth: "200px",
                // backgroundColor: agre_between?.prevValue !== '' && agre_between?.prevValue !== agre_between?.currValue ? "yellow" : ""
              }}
              placeholder={"Enter Farmer Name"}
              onChange={(e) =>
                handleInputChange("farmarName", e.target.value)
              }
              value={formData?.farmarName}
              disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            and
            {formErrors?.companyName && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.companyName + `)`}</span>}
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.companyName ? 'text-danger border-danger' : ''}`}
              style={{
                width: `${adjustInputWidth(formData.companyName, formErrors?.companyName || "Enter parties (e.g., Farmer and Company)")}px`,
                minWidth: "200px",
                // backgroundColor: agre_between?.prevValue !== '' && agre_between?.prevValue !== agre_between?.currValue ? "yellow" : ""
              }}
              placeholder={"Enter Company Name"}
              onChange={(e) =>
                handleInputChange("companyName", e.target.value)
              }
              value={formData?.companyName}
              disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            age
            {formErrors?.aggrement_age && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.aggrement_age + `)`}</span>}
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.aggrement_age ? 'text-danger border-danger' : ''}`}
              type="number"
              min={5}
              max={100}
              style={{
                // width: `${adjustInputWidth(formData.aggrement_age, formErrors?.aggrement_age || "Enter age (e.g., 25)")}px`,
                minWidth: "110px",
                // backgroundColor: agre_age?.prevValue !== '' && agre_age?.prevValue !== agre_age?.currValue ? "yellow" : ""
              }}
              placeholder={formErrors?.aggrement_age || "Enter age"}
              onChange={(e) =>
                handleInputChange("aggrement_age", e.target.value)
              }
              value={formData?.aggrement_age}
              disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            residing at
            {formErrors?.residing_at && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.residing_at + `)`}</span>}
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.residing_at ? 'text-danger border-danger' : ''}`}
              style={{
                width: `${adjustInputWidth(formData.residing_at, formErrors?.residing_at || "Enter address")}px`,
                minWidth: "200px",
                // backgroundColor: agre_residingAt?.prevValue !== '' && agre_residingAt?.prevValue !== agre_residingAt?.currValue ? "yellow" : ""
              }}
              placeholder={formErrors?.residing_at || "Enter address"}
              onChange={(e) =>
                handleInputChange("residing_at", e.target.value)
              }
              value={formData?.residing_at}
              disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            hereinafter called the Party of the first Part (which expression
            shall, unless excluded by or repugnant to the context, be deemed to
            include his heirs, executors, administrators and assigns,) and
            Shri/M/s.
            {formErrors?.Shri_M_s && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.Shri_M_s + `)`}</span>}
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mt-4 mb-4 low-opacity-placeholder ${formErrors?.Shri_M_s ? 'text-danger border-danger' : ''}`}
              style={{
                width: `${adjustInputWidth(formData.Shri_M_s, formErrors?.Shri_M_s || "Enter company name")}px`,
                minWidth: "200px",
                // backgroundColor: Agre_shri_M?.prevValue !== '' && Agre_shri_M?.prevValue !== Agre_shri_M?.currValue ? "yellow" : ""
              }}
              placeholder={formErrors?.Shri_M_s || "Enter company name"}
              onChange={(e) =>
                handleInputChange("Shri_M_s", e.target.value)
              }
              value={formData?.Shri_M_s}
              disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            a Pvt./Public Limited Company incorporated under the provisions of
            Companies Act, 1956 and having its registered office at
            {formErrors?.registered_office_at && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.registered_office_at + `)`}</span>}
            <input
              className={`mx-1 border-0 border-bottom border-secondary text-center mb-4 low-opacity-placeholder ${formErrors?.registered_office_at ? 'text-danger border-danger' : ''}`}
              style={{
                width: `${adjustInputWidth(formData.registered_office_at, formErrors?.registered_office_at || "Enter office address")}px`,
                minWidth: "200px",
                // backgroundColor: agreem_Reg_office_at?.prevValue !== '' && agreem_Reg_office_at?.prevValue !== agreem_Reg_office_at?.currValue ? "yellow" : ""
              }}
              placeholder={formErrors?.registered_office_at || "Enter office address"}
              onChange={(e) =>
                handleInputChange("registered_office_at", e.target.value)
              }
              value={formData?.registered_office_at}
              disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
            />
            hereinafter called the Party of second Part (which expression shall,
            unless excluded by or repugnant to the context be deemed to include
            its successors and assigns.)
          </p>
          <p>
            Whereas the party of the first Part is the owner/cultivator of the
            agricultural land bearing, the following particulars, namely:-
          </p>

          {/* UPDATED FARMERS TABLE WITH DELETE FUNCTIONALITY */}
          <div
            id="table"
            className="w-100 overflow-hidden border bg-white border-secondary rounded"
          >
            {/* Header */}
            <div
              id="head"
              className="d-flex w-100 rounded-top border-bottom border-secondary "
              style={{ backgroundColor: "#CCE3FF" }}
            >
              <div className="col-6 d-flex">
                <h4 className={`col-1 p-2 justify-content-center d-flex align-items-center border-secondary border-end ${hasColumnError(tableErrors, 'Village_Name') ? "bg-danger" : ''} `}>
                  Sr.
                </h4>
                <h4 className={`col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end ${hasColumnError(tableErrors, 'Village_Name') ? "bg-danger" : ''} `}>
                  Village of Farmers
                </h4>
                <h4 className={`col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end ${hasColumnError(tableErrors, 'Farmer_Name') ? 'bg-danger' : ''} `}>
                  Name of Farmers
                </h4>
                <h4 className={`col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end ${hasColumnError(tableErrors, 'Survey_No') ? 'bg-danger' : ''} `}>
                  Survey No.
                </h4>
              </div>
              <div className="col-6 d-flex">
                <h4 className={`col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end ${hasColumnError(tableErrors, 'Area_Hectar') ? 'bg-danger' : ''} `}>
                  Area in Hectare
                </h4>
                <h4 className={`col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end ${hasColumnError(tableErrors, 'District_Name') ? 'bg-danger' : ''} `}>
                  District
                </h4>
                <h4 className={`col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end ${hasColumnError(tableErrors, 'Tehsil') ? 'bg-danger' : ''} `}>
                  Tehsil
                </h4>
                <h4 className="col-3 p-2 justify-content-center d-flex align-items-center">
                  State
                </h4>
              </div>
            </div>

            {/* Dynamic Rows with individual delete buttons */}
            {rows.map((row, index) => (

              <div
                key={index}
                className="d-flex border-bottom border-secondary"
              >

                <div className="col-6 d-flex">
                  <div className="col-1 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <h4>{index + 1}</h4>
                  </div>
                  <div className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <input
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      placeholder={formErrors?.Village_Name ? formErrors?.Village_Name : "Enter village name"}
                      name="Village_Name"
                      onChange={(e) =>
                        handleFarmerInputChange(index, "Village_Name", e.target.value)
                      }
                      value={row?.Village_Name}
                      disabled={isDisableFarmarTable}
                    />
                    {/* ["pendingAtMBA", "pendingAtMB", "forwardToSponsorAterApproval"].includes(appdata1?.appStatusLevel) */}
                  </div>
                  <div className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <input
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      placeholder={formErrors?.Farmer_Name ? formErrors?.Farmer_Name : "Enter farmer name"}
                      name="Farmer_Name"
                      onChange={(e) =>
                        handleFarmerInputChange(index, "Farmer_Name", e.target.value)
                      }
                      value={row?.Farmer_Name}
                      disabled={isDisableFarmarTable}
                    />
                  </div>
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <input
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      placeholder={formErrors?.Survey_No ? formErrors?.Survey_No : "Enter survey no."}
                      name="Survey_No"
                      onChange={(e) =>
                        handleFarmerInputChange(index, "Survey_No", e.target.value)
                      }
                      value={row?.Survey_No}
                      disabled={isDisableFarmarTable}
                    />
                  </div>
                </div>
                <div className="col-6 d-flex">
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <input
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      placeholder={formErrors?.Area_Hectar ? formErrors?.Area_Hectar : "Enter area"}
                      name="Area_Hectar"
                      onChange={(e) =>
                        handleFarmerInputChange(index, "Area_Hectar", e.target.value)
                      }
                      value={row?.Area_Hectar}
                      disabled={isDisableFarmarTable}
                    />
                  </div>

                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <select
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      name="District_Name"
                      value={row?.District_Name}
                      onChange={(e) => handleFarmerInputChange(index, "District_Name", e.target.value)}
                      disabled={isDisableFarmarTable}
                    >
                      <option value="" disabled>
                        {formErrors?.District_Name || "Select District"}
                      </option>
                      {districtOptions.map((district: any) => (
                        <option key={district} value={district}>
                          {district}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <select
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      name="Tehsil"
                      value={row?.Tehsil}
                      onChange={(e) => handleFarmerInputChange(index, "Tehsil", e.target.value)}
                      disabled={isDisableFarmarTable}
                    >
                      <option value="" disabled>
                        {formErrors?.Tehsil || "Select Tehsil"}
                      </option>
                      {
                        Object.keys(appdata1 || {}).length > 0 ?
                          (
                            <option value={row?.Tehsil}>
                              {row?.Tehsil}
                            </option>
                          ) :
                          (
                            row?.TehsilOptions?.map((tehsil: any, index) => (
                              <option value={tehsil?.Taluka}>
                                {tehsil?.Taluka}
                                {/* {row?.Tehsil} */}
                              </option>
                            )
                            )
                          )
                      }




                    </select>
                  </div>

                  {/* <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <input
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      placeholder={formErrors?.Tehsil ? formErrors?.Tehsil : "Enter tehsil name (e.g., Ahmedabad)"}
                      name="Tehsil"
                      onChange={(e) =>
                        handleFarmerInputChange(index, "Tehsil", e.target.value)
                      }
                      value={row?.Tehsil}
                      disabled={isDisableFarmarTable}
                    />
                  </div>
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    <input
                      className="mx-1 border-0 w-100 low-opacity-placeholder"
                      placeholder={formErrors?.District_Name ? formErrors?.District_Name : "Enter district name (e.g., Ahmedabad)"}
                      name="District_Name"
                      onChange={(e) =>
                        handleFarmerInputChange(index, "District_Name", e.target.value)
                      }
                      value={row?.District_Name}
                      disabled={isDisableFarmarTable}
                    />
                  </div> */}

                  <div className="col-3 p-2 justify-content-center d-flex align-items-center position-relative">
                    <input
                      className="mx-1 border-0 w-75 text-center"
                      placeholder={formErrors?.State ? formErrors?.State : "Enter state name"}
                      name="State"
                      onChange={(e) =>
                        handleFarmerInputChange(index, "State", e.target.value)
                      }
                      value={row?.State}
                      disabled={true}
                    />
                    {rows.length > 1 && roleIdentifier === "SPO" && (
                      <button
                        className="btn btn-outline-danger ms-1"
                        onClick={() => deleteRow(index)}
                        title="Delete this row"
                        disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                          (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Add More and Delete buttons */}
          {!isDisableFarmarTable &&
            <div className="d-flex gap-2">
              <button
                className="btn btn-transparent text-info my-2"
                style={{ fontSize: "1.1rem" }}
                onClick={addRow}
                disabled={isDisableFarmarTable}
              >
                <i className="feather feather-plus-circle me-2"></i>Add More
              </button>
            </div>
          }

          <p className="mt-3">
            And whereas the party of the second Part is trading in agricultural
            produce and also providing technical know-how in respect of land
            preparation, nursery, fertilization, pest management, irrigation,
            harvesting and other related aspects of Cultivation Production of
            crops;
          </p>
          <p>
            And whereas the party of the second Part is interested in the items
            of the agricultural produce more particularly mentioned in the
            Schedule annexed hereunder;
          </p>
          <p>
            And whereas at the request of the party of the second Part, the
            party of the first part has agreed to cultivate and produce the
            items of agricultural produce mentioned in the Schedule annexed
            hereunder;
          </p>
          <p>
            And whereas the parties hereto have agreed to reduce in writing the
            terms and conditions stipulated in the matter hereinafter appearing;
          </p>
          <p>
            Now, these presents witnessed and the parties hereby agree as
            follows:
          </p>


          {["periodOfMonths", "periodOfMonths2", "contractedProduce", "registrationAuthority", "registrationDate", "regardingAuthority",
            "landDescriptionReference", "singlePointRegistrationDate", "singlePointAuthorityName", "feeAuthority", "registeringAuthorityName",
            "addressChangeAuthority", "dateOFAgreement", "deliveryPoint", "costOFDelivery", "periodOfDelivery", "dateOfScheduled", "modeOfPayment",
            "placeOfPayment", "grade", "specifications", "quantity", "price"].some(key => key in formErrors) &&
            <span className="text-danger small mx-2" style={{ fontSize: "20px" }}>{`(All Fields are Required in below conditions.)`}</span>}
          {/* CONDITIONS TABLE */}
          <ConditionsTable
            conditionsData={conditionsData}
            onConditionsChange={setConditionsData}
            // setConditionsData={setConditionsData}
            originalData={sponsorRegistration}
            checked={checked1}
            // setTableConditionData={setTableConditionData}
            // tableConditionData={tableConditionData}
            reviewedData1={reviewedData1}
            isReadOnly={isEnable1 === true}
            condFields={condFields}     //<----
            setCondFields={setCondFields} //<---
            setFormErrors={setFormErrors}
            getCondTableData={getCondTableData}
          />

          {/* ==Form-O begin== */}
          <div className='bg-white text-black mb-3'>
            <div className="text-center  mb-4">
              <h2>FORM - O</h2>
              <h2>[SEE RULE 121(10)]</h2>
              <h2 className='mx-5 px-5'>FORM FOR INFORMING THE PRODUCE PURCHASED WITH AN INTENTION TO EXPORT OR PROCESSING BY THE CONTRACT FARMING SPONSOR</h2>
            </div>
            <div>
              <p style={{ fontSize: '1.25rem' }}>Return for the period of
                {formErrors?.return_for_period && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.return_for_period + `)`}</span>}
                <input
                  className={`mx-1 border-0 border-bottom text-center border-secondary mb-4 ${formErrors?.return_for_period ? 'border-danger' : ''}`}
                  style={{
                    width: `${adjustInputWidth(formData?.return_for_period)}px`,
                    minWidth: '200px'
                  }}
                  value={formData?.return_for_period}
                  onChange={(e) => handleInputChange('return_for_period', e.target.value)}
                  placeholder={`${formErrors?.return_for_period ? formErrors?.return_for_period : 'Enter here...'}`}
                  disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                    (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                />

              </p>
            </div>

            <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>

              <div className="d-flex w-100 text-center">

                <div className="col-6 d-flex">
                  <div className="col-1 border-secondary border-end"></div>
                  <div className="col-2 text-danger border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field1}</div>
                  <div className="col-2 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field2}</div>
                  <div className="col-2 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field3}</div>

                  <div className="col-5 d-flex">
                    <div className="col-6 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field4}</div>
                    <div className="col-6 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field5}</div>
                  </div>
                </div>
                <div className="col-6 d-flex">
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field6}</div>
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field7}</div>
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field8}</div>
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.o_field9}</div>
                </div>
              </div>

              <div id='head' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' style={{ backgroundColor: "#CCE3FF" }}>
                <div className='col-6 d-flex'>
                  <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>Sr. No.</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field1 ? 'bg-danger' : ''}`}>Quarter for which report pertains</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field2 ? 'bg-danger' : ''}`}>Total quantity of agricultural produce purchased by contract farming sponsor in tonnes</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field3 ? 'bg-danger' : ''}`}>Total value of produce purchased</h4>
                  <div className='col-5 d-flex'>
                    <h4 className={`col-6 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field4 ? 'bg-danger' : ''}`}>Total amount of supervision charges assessed</h4>
                    <h4 className={`col-6 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field5 ? 'bg-danger' : ''}`}>Total amount of supervision charges paid in Rs. (Treasury Challan No. & Date)</h4>
                  </div>
                </div>
                <div className='col-6 d-flex'>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field6 ? 'bg-danger' : ''}`}>Total quantity of agricultural produce purchased for export in tones</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field7 ? 'bg-danger' : ''}`}>Quantity of agrucultural produce purchased for processing and exporting in tonnes</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field8 ? 'bg-danger' : ''}`}>Quantity of agricultural produce exported</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.o_field9 ? 'bg-danger' : ''}`}>Quantity of agricultural produce processed and exported</h4>
                  {/* <h4 className='col-2 p-2 justify-content-center d-flex'>Remarks</h4> */}
                </div>
              </div>
              <div id='body' className='d-flex w-100 text-center rounded-top border-bottom border-secondary'>
                <div className='col-6 d-flex'>
                  <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                    <p>1</p>
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("o_field1", e.target.value)}
                      value={formData?.o_field1}
                    />
                    {/* <p className="text-break">{'mnbvcxsdfghjiuytf bvcdfghjkuytr xcvbnjhgfdrtyu'}</p> */}
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("o_field2", e.target.value)}
                      value={formData?.o_field2}
                    />
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("o_field3", e.target.value)}
                      value={formData?.o_field3}
                    />
                  </div>
                  <div className='col-5 d-flex'>
                    <div className='col-6 justify-content-center d-flex border-secondary border-end'>
                      <textarea className="form-control col-12" placeholder="Enter here..."
                        style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                        disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                          (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                        onChange={(e) => handleInputChange("o_field4", e.target.value)}
                        value={formData?.o_field4}
                      />
                    </div>
                    <div className='col-6 justify-content-center d-flex border-secondary border-end'>
                      <textarea className="form-control col-12" placeholder="Enter here..."
                        style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                        disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                          (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                        onChange={(e) => handleInputChange("o_field5", e.target.value)}
                        value={formData?.o_field5}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-6 d-flex'>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("o_field6", e.target.value)}
                      value={formData?.o_field6}
                    />
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("o_field7", e.target.value)}
                      value={formData?.o_field7}
                    />
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("o_field8", e.target.value)}
                      value={formData?.o_field8}
                    />
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("o_field9", e.target.value)}
                      value={formData?.o_field9}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className=' mt-4'>
              <p style={{ fontSize: '1.25rem' }}>
                It is hereby certified that I/We undertake that the quantity of agricultural produce purchased for export/processing shall
                be exported or processed by me/us. Failure to do so shall result in action/penalty against me/us as per the provisions
                of
                {formErrors?.provisions_of && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.provisions_of + `)`}</span>}
                <input
                  className={`mx-1 border-0 border-bottom text-center border-secondary mb-2 ${formErrors?.provisions_of ? 'border-danger' : ''}`}
                  style={{
                    width: `${adjustInputWidth(formData?.provisions_of)}px`,
                    minWidth: '200px'
                  }}
                  value={formData?.provisions_of}
                  onChange={(e) => handleInputChange('provisions_of', e.target.value)}
                  placeholder={`${formErrors?.provisions_of ? formErrors?.provisions_of : 'Enter here...'}`}
                  disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                    (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                />

                The Gujarat State Agricultural Produce Markets Act, 1963 (Guj. Act No. 20 of 1964) and rules
                made thereunder or conditions of registrations given to me/us which I am/we are ware of.
              </p>
              <div className='d-flex flex-column align-items-end'>
                {formErrors?.sign_CF_sponsor && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.sign_CF_sponsor + `)`}</span>}
                <input
                  className={`w-25 mx-1 border-0 border-bottom text-center border-secondary mb-4 ${formErrors?.sign_CF_sponsor ? 'border-danger' : ''}`}
                  style={{
                    width: `${adjustInputWidth(formData?.sign_CF_sponsor)}px`,
                    minWidth: '200px'
                  }}
                  value={formData?.sign_CF_sponsor}
                  onChange={(e) => handleInputChange('sign_CF_sponsor', e.target.value)}
                  placeholder={`${formErrors?.sign_CF_sponsor ? formErrors?.sign_CF_sponsor : 'Sign here...'}`}
                  disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                    (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                />
                <p style={{ fontSize: '1.25rem' }}>

                  Signature of the Contract Farming Sponsor.
                </p>
              </div>
            </div>

          </div>
          {/* ==Form-O end== */}

          {/* ==Form-P begin== */}
          <div className='mb-5 bg-white text-black'>
            <div className="text-center  mb-4">
              <h2>FORM - P</h2>
              <h2>[SEE RULE 121(9)]</h2>
              <h2 className='mx-5 px-5'>FORM OF ANNUAL ACCOUNTS OF CONTRACT FARMING SPONSOR</h2>
            </div>

            <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>

              <div className="d-flex w-100 text-center">
                <div className="col-6 d-flex">
                  <div className="col-1 border-secondary border-end"></div>
                  <div className="col-3 text-danger border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field1}</div>
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field2}</div>
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field3}</div>
                  <div className="col-2 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field4}</div>
                </div>
                <div className="col-6 d-flex">
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field5}</div>
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field6}</div>
                  {/* <div className='d-flex h-100'> */}
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field7}</div>
                  <div className="col-3 text-danger small border-secondary border-end" style={{ fontSize: "15px" }}>{formErrors?.p_field8}</div>
                  {/* </div> */}
                </div>
              </div>

              <div id='head' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' style={{ backgroundColor: "#CCE3FF" }}>
                <div className='col-6 d-flex'>
                  <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>Sr. No.</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.p_field1 ? 'bg-danger' : ''}`}>Name of the commodity</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.p_field2 ? 'bg-danger' : ''}`}>No. of farmers with whom contracts signed</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.p_field3 ? 'bg-danger' : ''}`}>Area in ha. under contract Farming Agreement</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.p_field4 ? 'bg-danger' : ''}`}>Quantity purchased in tones</h4>
                </div>
                <div className='col-6 d-flex'>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.p_field5 ? 'bg-danger' : ''}`}>Total value and quantity of produce purchased</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.p_field6 ? 'bg-danger' : ''}`}>Values paid to the farmers</h4>
                  <div className='col-6'>
                    <div className='border-bottom border-secondary'>
                      <h4 className={`p-2 justify-content-center d-flex ${formErrors?.p_field8 ? 'bg-danger' : ''}`}>Payment outstanding for more than 15 days</h4>
                    </div>
                    <div className='d-flex h-100'>
                      <h4 className={`col-6 p-2 justify-content-center d-flex border-secondary border-end ${formErrors?.p_field7 ? 'bg-danger' : ''}`}>No. of farmers</h4>
                      <h4 className={`col-6 p-2 justify-content-center d-flex ${formErrors?.p_field8 ? 'bg-danger' : ''}`}>Amount in Rs.</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div id='body' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' >
                <div className='col-6 d-flex'>
                  <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                    <p>1</p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12 m-0" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("p_field1", e.target.value)}
                      value={formData?.p_field1}
                    />
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("p_field2", e.target.value)}
                      value={formData?.p_field2}
                    />
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("p_field3", e.target.value)}
                      value={formData?.p_field3}
                    />
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("p_field4", e.target.value)}
                      value={formData?.p_field4}
                    />
                  </div>
                </div>
                <div className='col-6 d-flex'>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("p_field5", e.target.value)}
                      value={formData?.p_field5}
                    />
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <textarea className="form-control col-12" placeholder="Enter here..."
                      style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                      disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                        (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                      onChange={(e) => handleInputChange("p_field6", e.target.value)}
                      value={formData?.p_field6}
                    />
                  </div>
                  <div className='col-6'>
                    <div className='d-flex h-100'>
                      <div className='col-6 justify-content-center d-flex border-secondary border-end'>
                        <textarea className="form-control col-12" placeholder="Enter here..."
                          style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                          disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                            (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                          onChange={(e) => handleInputChange("p_field7", e.target.value)}
                          value={formData?.p_field7}
                        />
                      </div>
                      <div className='col-6 justify-content-center d-flex'>
                        <textarea className="form-control col-12" placeholder="Enter here..."
                          style={{ scrollbarColor: '#7db0fcff #ffffffff', scrollbarWidth: 'thin' }}
                          disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                            (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                          onChange={(e) => handleInputChange("p_field8", e.target.value)}
                          value={formData?.p_field8}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ==Form-P end== */}

          {/* Signature section remains the same */}
          <div>
            <p>
              In witness whereof the parties herein hereunto set and subscribed
              their respective hands and seals the day, month and year first
              above written.
            </p>
            <div className="d-flex justify-content-between">
              <div className="w-50">
                <p>
                  Signed, sealed and delivered by the within named 'Party of the
                  first Part' in the presence of
                </p>
                {formErrors?.first_party && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.first_party + `)`}</span>}
                <p className="">
                  {/* 1 */}

                  <input
                    className={`mx-1 border-0 border-bottom border-secondary text-center low-opacity-placeholder ${formErrors?.first_party ? 'text-danger border-danger' : ''}`}
                    style={{
                      width: `${adjustInputWidth(formData.first_party, formErrors?.first_party || "Enter witness name")}px`,
                      minWidth: "200px",
                      // backgroundColor: FirstPartyPresenceName?.prevValue !== '' && FirstPartyPresenceName?.prevValue !== FirstPartyPresenceName?.currValue ? "yellow" : ""
                    }}
                    placeholder={formErrors?.first_party || "Enter witness name"}
                    onChange={(e) =>
                      handleInputChange("first_party", e.target.value)
                    }
                    value={formData?.first_party}
                    disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                      (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                  />
                </p>
                {/* <p>
                  2
                  <input
                    className="mx-1 border-0 border-bottom border-secondary text-center low-opacity-placeholder"
                    style={{
                      width: `${adjustInputWidth(formData.higherAuthName)}px`,
                      minWidth: "200px",
                    }}
                    onChange={(e) =>
                      handleInputChange("higherAuthName", e.target.value)
                    }
                    placeholder=""
                  />
                </p> */}
              </div>
            </div>
            <div className="d-flex justify-content-between mt-4">
              <div className="w-50">
                <p>
                  Signed, sealed and delivered by the within named 'Party of the
                  second Part' in the presence of
                </p>
                {formErrors?.second_party && <span className="text-danger small mx-2" style={{ fontSize: "12px" }}>{`(` + formErrors?.second_party + `)`}</span>}
                <p className="">
                  {/* 1 */}
                  <input
                    className={`mx-1 border-0 border-bottom border-secondary text-center low-opacity-placeholder ${formErrors?.second_party ? 'text-danger border-danger' : ''}`}
                    style={{
                      width: `${adjustInputWidth(formData.second_party, formErrors?.second_party || "Enter witness name")}px`,
                      minWidth: "200px",
                      // backgroundColor: SecondPartyPresenceName?.prevValue !== '' && SecondPartyPresenceName?.prevValue !== SecondPartyPresenceName?.currValue ? "yellow" : ""
                    }}
                    placeholder={formErrors?.second_party || "Enter witness name"}
                    onChange={(e) =>
                      handleInputChange("second_party", e.target.value)
                    }
                    value={formData?.second_party}
                    disabled={appdata1?.appStatusLevel == 'forwardToSponsorAterApproval' ? true :
                      (roleIdentifier === "SPO" ? isEnable1 === true : isEnable1)}
                  />
                </p>
                {/* <p>
                  2
                  <input
                    className="mx-1 border-0 border-bottom border-secondary text-center low-opacity-placeholder"
                    style={{
                      width: `${adjustInputWidth(formData.higherAuthName)}px`,
                      minWidth: "200px",
                    }}
                    onChange={(e) =>
                      handleInputChange("higherAuthName", e.target.value)
                    }
                    placeholder=""
                  />
                </p> */}
              </div>
              <div className="h-25 pe-5">
              </div>
            </div>
          </div>

        </div>
      </div>

      {roleIdentifier === "SPO" && reviewedData1?.buttonName && appdata1?.Status !== "pending" && appdata1?.appStatusLevel !== "pendingAtMBA" && appdata1?.appStatusLevel !== "pendingAtMBMD" ? (
        <div className="d-flex justify-content-end mb-3 me-5">
          <button className="btn btn-info"
            data-bs-target="#sponsorModalToggle"
            data-bs-toggle="modal"
            data-bs-dismiss="modal"
            onClick={() => { setChecked1(!checked1) }}
          >
            Forward to Marketing Board Administrator
          </button>
        </div>
      ) : ""}
      {
        roleIdentifier === "MBA" && reviewedData1?.buttonName ? (
          <div className="d-flex justify-content-end mb-3 me-5">
            <button className="btn btn-info"
              data-bs-target="#mbaSponsorToggle"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
              onClick={() => setAppstatus(reviewedData1?.buttonName[0])}>{reviewedData1?.buttonName[0]?.buttonLabel}
            </button>
          </div>
        ) : ""
      }
      {roleIdentifier === "MBMD" && reviewedData1?.buttonName && (
        <div className="d-flex justify-content-end mb-5 me-5 gap-3 pe-5">
          {reviewedData1.buttonName.map((button, index) => {
            // Define button styling based on status or label
            const getButtonClass = (status) => {
              switch (status) {
                case "pending":
                  return "btn btn-info px-4";
                case "reject":
                  return "btn btn-outline-secondary";
                case "permanentReject":
                  return "btn btn-outline-danger px-4";
                default:
                  return "btn btn-outline-primary px-4";
              }
            };

            // Define modal target based on status
            const getModalTarget = (status) => {
              switch (status) {
                case "pending":
                  return "#approveModal";
                case "reject":
                  return "#raiseQueryModal";
                case "permanentReject":
                  return "#rejectModal";

              }
            };

            return (
              <button
                key={index}
                className={getButtonClass(button.status)}
                data-bs-target={getModalTarget(button.status)}
                data-bs-toggle="modal"
                data-bs-dismiss="modal"
                onClick={() => setAppstatus(button)}
              >
                {button.buttonLabel}
              </button>
            );
          })}
        </div>
      )}

      {submitLoading && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          aria-hidden="true"
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div
                className="modal-body d-flex flex-column justify-content-center align-items-center"
                style={{ minHeight: 150 }}
              >
                {/* Spinner */}
                <div className="spinner-border text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>

                {/* Status text */}
                <h4 className="text-primary">Form Submitting...</h4>
              </div>
            </div>
          </div>
        </div>
      )}

      {uploadLoading && (
        <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.3)", zIndex: 1050 }}>
          <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Uploading...</span>
            </div>
            <div className="fw-bold">Uploading, please wait...</div>
          </div>
        </div>
      )}


      {/* SPO */}
      <div className="col-xl-4">
        <div className="card-body">
          {/* Modal */}
          <div
            className="modal fade"
            id="sponsorModalToggle"
            aria-hidden="false"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className="modal-title"
                    id="exampleModalToggleLabel"
                  >
                    Confirmation

                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  Are you sure you want to submit this agreement form to the Marketing Board Administrator for review?
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-3"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >Cancel
                  </button>
                  <button
                    className="btn btn-info"
                    // data-bs-target="#exampleModalToggle2"
                    // data-bs-toggle="modal"
                    data-bs-dismiss="modal"
                    onClick={handleAgreementSubmit}
                  >
                    Yes Forward
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Modal */}
          <div
            className={`modal fade ${openModel ? "show d-block" : ""}`}
          // id="exampleModalToggle2"
          // aria-hidden="true"
          // aria-labelledby="exampleModalToggleLabel2"
          // tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className={`modal-title ${((Object.keys(formErrors)?.length !== 0 || Object.keys(tableErrors).length !== 0) || !(role == 'self' || (behalfFile && (behalfFile?.length > 0)))) && 'text-danger'} `}
                    id="exampleModalToggleLabel2"
                  >
                    {(Object.keys(formErrors)?.length == 0 && Object.keys(tableErrors).length == 0) && (role == 'self' || (behalfFile && (behalfFile?.length > 0))) ? (
                      <>
                        <i className="feather feather-check-circle text-success me-2"></i>
                        Success
                      </>
                    ) : (
                      "Failed to Submit the form"
                    )}
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    // data-bs-dismiss="modal"
                    // aria-label="Close"
                    onClick={() => {
                      navigate((Object.keys(formErrors)?.length == 0 && Object.keys(tableErrors).length == 0) && (role == 'self' || (behalfFile && (behalfFile?.length > 0))) && routes.sponsorDashboard);
                      setOpenModel(false);
                    }}
                  />
                </div>
                <div className={`modal-body ${((Object.keys(formErrors)?.length !== 0 || Object.keys(tableErrors).length !== 0) || !(role == 'self' || (behalfFile && (behalfFile?.length > 0)))) && 'text-danger'}`}>
                  {
                    (Object.keys(formErrors)?.length == 0 && Object.keys(tableErrors).length == 0) && (role == 'self' || (behalfFile && (behalfFile?.length > 0))) ? `Your agreement form has been successfully 
                  submitted to the Marketing Board Administrator for review. You can 
                  track its status in your dashboard.`
                      :
                      `Enter the required field's value`
                  }

                </div>
                <div className="modal-footer">

                  <button
                    type="button"
                    className="btn btn-info me-3 w-100"
                    // data-bs-dismiss="modal"
                    // aria-label="Close"
                    onClick={() => {
                      (Object.keys(formErrors)?.length == 0 && Object.keys(tableErrors).length == 0) && (role == 'self' || (behalfFile && (behalfFile?.length > 0))) && navigate(routes.sponsorDashboard);
                      setOpenModel(false);
                    }}
                  >Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /Modal */}

        </div>

      </div>

      {/* MBA */}
      <div className="col-xl-4">
        <div className="card-body">
          {/* Modal */}
          <div
            className="modal fade"
            id="mbaSponsorToggle"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className="modal-title"
                    id="exampleModalToggleLabel"
                  >
                    Confirmation

                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  Are you sure you want to submit this agreement form to the Marketing Board Administrator for review?
                </div>

                <div className="modal-body">
                  <p>Are you sure you want to approve this application. ?</p>
                  <textarea
                    className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                    style={{ fontSize: '1.25rem' }}
                    rows={3}
                    onChange={(e) => { setComment(e.target.value) }}
                    placeholder="Enter your remarks here."
                  />
                  {comment.trim() === '' && (
                    <small className="text-danger">* Remarks are required</small>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-3"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >Cancel
                  </button>
                  <button
                    className="btn btn-info"
                    data-bs-dismiss="modal"
                    onClick={handleForwardToMD}
                  >
                    Yes Forward
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

      {/* MBMD */}
      {/* APPROVE */}
      <div className="col-xl-4">
        <div className="card-body">
          <div
            className="modal fade"
            id="approveModal"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className="modal-title"
                    id="exampleModalToggleLabel"
                  >
                    Application Confirmation

                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to approve this application. ?</p>
                  <textarea
                    className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                    style={{ fontSize: '1.25rem' }}
                    rows={3}
                    onChange={(e) => { setComment(e.target.value) }}
                    placeholder="Enter your remarks here."
                  />
                  {comment.trim() === '' && (
                    <small className="text-danger">* Remarks are required</small>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-3"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >Cancel
                  </button>
                  <button
                    className="btn btn-info"
                    // data-bs-target="#approveModal2"
                    // data-bs-toggle="modal"
                    {...(isModalClose ? { "data-bs-dismiss": "modal" } : {})}
                    onClick={handleApproved}
                  >
                    Yes Approve
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* ///Success ALERT */}
          <div
            className="modal fade"
            id="approveModal2"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel2"
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className="modal-title"
                    id="exampleModalToggleLabel2"
                  >
                    <i className="feather feather-check-circle text-success me-2"></i>
                    Success
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  Application approved successfully and sent to Sponsor.
                </div>
                <div className="modal-footer">

                  <button
                    type="button"
                    className="btn btn-info me-3 w-100"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Raise Query */}
      <div className="col-xl-4">
        <div className="card-body">
          <div
            className="modal fade"
            id="raiseQueryModal"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className="modal-title"
                    id="exampleModalToggleLabel"
                  >
                    Raise Query: Sent Back to Sponsor

                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to raise query ?</p>
                  <textarea
                    className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                    style={{ fontSize: '1.25rem' }}
                    rows={3}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Enter your remarks here. *"
                    required
                  />
                  {comment.trim() === '' && (
                    <small className="text-danger">* Remarks are required</small>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-3"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >Cancel
                  </button>
                  <button
                    className="btn btn-info"
                    // data-bs-target="#raiseQueryModal2"
                    // data-bs-toggle="modal"
                    {...(isModalClose ? { "data-bs-dismiss": "modal" } : {})}
                    onClick={handleApproved}
                  >
                    Yes, Sent back to Sponsor
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <div
            className="modal fade"
            id="raiseQueryModal2"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel2"
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className="modal-title"
                    id="exampleModalToggleLabel2"
                  >
                    <i className="feather feather-check-circle text-success me-2"></i>
                    Query has been raised
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  Application successfully sent back to sponsor
                </div>
                <div className="modal-footer">

                  <button
                    type="button"
                    className="btn btn-info me-3 w-100"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >Ok
                  </button>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* Reject */}
      <div className="col-xl-4">
        <div className="card-body">
          <div
            className="modal fade"
            id="rejectModal"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex={-1}
          >
            {uploadLoading && (
              <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.3)", zIndex: 1050 }}>
                <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
                  <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Uploading...</span>
                  </div>
                  <div className="fw-bold">Uploading, please wait...</div>
                </div>
              </div>
            )}
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4
                    className="modal-title"
                    id="exampleModalToggleLabel"
                  >
                    Application Rejection

                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to reject this application ?</p>

                  <input type="file"
                    className="form-control w-75 border border-dark mb-2"
                    name="rejectionFile"
                    onChange={(e) => handleFileChange(e, "rejectionFile")}
                  />
                  {newlyUploaded.rejectionFile && (
                    <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.rejectionFile?.fileName}</p>
                  )}
                  <p>Upload File (optional)</p>
                  <textarea
                    className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                    style={{ fontSize: '1.25rem' }}
                    rows={3}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Enter your remarks here. *"
                    required
                  />
                  {comment.trim() === '' && (
                    <small className="text-danger">* Remarks are required</small>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-3"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >Cancel
                  </button>
                  <button
                    className="btn btn-info"
                    // data-bs-target="#rejectModal2"
                    // data-bs-toggle="modal"
                    {...(isModalClose ? { "data-bs-dismiss": "modal" } : {})}
                    onClick={handleApproved}
                  >
                    Yes, Sent back to Sponsor
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Model for befalf doc review... */}
      <div className="card-body">
        <div
          className="modal fade"
          id="befalf_doc_review"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex={-1}
        >

          <div className="modal-dialog modal-fullscreen modal-dialog-centered fullscreen-pdf">
            <div className="modal-content">
              <div className="modal-header">
                <h4
                  className="modal-title"
                  id="exampleModalToggleLabel"
                >
                  Confirmation

                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <div className="modal-body p-0 pdf-body">
                <div className="document-viewer h-100" style={{ flex: "1", overflowY: "auto", overflowX: "hidden" }}>
                  {file?.mimeType?.startsWith("image/") && (
                    <div className="text-center bg-light rounded p-3">
                      <img
                        src={file?.fileData}
                        alt={file?.fileName}
                        className="img-fluid rounded shadow-sm"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>
                  )}

                  {file?.mimeType === "application/pdf" && (
                    <div className="border rounded overflow-hidden " style={{ flex: "1", flexDirection: 'column', overflowY: "auto", overflowX: "hidden", height: "100%" }}>
                      <iframe
                        src={pdfUrl}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                        className="border-0"
                      />
                    </div>
                  )}

                  {!file?.mimeType?.startsWith("image/") && file?.mimeType !== "application/pdf" && (
                    <div className="alert alert-info d-flex align-items-center" role="alert">
                      <i className="bi bi-info-circle-fill me-2"></i>
                      <div>
                        Preview not available for this file type.

                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary me-3"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >Close
                </button>
              </div>

            </div>
          </div>
        </div>

      </div>

      {/* Model for rejection File doc review... */}
      <div className="card-body">
        <div
          className="modal fade"
          id="rejection_attachement"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex={-1}
        >

          <div className="modal-dialog modal-fullscreen modal-dialog-centered fullscreen-pdf">
            <div className="modal-content">
              <div className="modal-header">
                <h4
                  className="modal-title"
                  id="exampleModalToggleLabel"
                >
                  Rejection Attachement

                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <div className="modal-body p-0 pdf-body">
                <div className="document-viewer h-100" style={{ flex: "1", overflowY: "auto", overflowX: "hidden" }}>
                  {rejectFile?.mimeType?.startsWith("image/") && (
                    <div className="text-center bg-light rounded p-3">
                      <img
                        src={rejectFile?.fileData}
                        alt={rejectFile?.fileName}
                        className="img-fluid rounded shadow-sm"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>
                  )}

                  {rejectFile?.mimeType === "application/pdf" && (
                    <div className="border rounded overflow-hidden " style={{ flex: "1", flexDirection: 'column', overflowY: "auto", overflowX: "hidden", height: "100%" }}>
                      <iframe
                        src={pdfUrl_RejectFile}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                        className="border-0"
                      />
                    </div>
                  )}

                  {!rejectFile?.mimeType?.startsWith("image/") && rejectFile?.mimeType !== "application/pdf" && (
                    <div className="alert alert-info d-flex align-items-center" role="alert">
                      <i className="bi bi-info-circle-fill me-2"></i>
                      <div>
                        Preview not available for this file type.

                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary me-3"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >Close
                </button>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>
  );
};

export default SponsorAgreementP1;
